import React from "react";
import useBenchmarkInsurances from "./useBenchmarkInsurances";
import InsuranceInformationDetail from "../InsuranceInformationDetail";
import { Button, Grid, Tooltip } from "@mui/material";
import LoadingSpinner from "components/LoadingSpinner";
import { Edit as EditIcon } from "@mui/icons-material";
import { API_BASE_URL_BENCHMARK, USER_ROLES } from "static/constants";
import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";
import FormTextField from "components/FormFields/FormTextField";
import SubmitButton from "components/Button/SubmitButton";

const BenchmarkInsurances = () => {
  const {
    userRole,
    isSubmitting,
    isSubmitClicked,
    benchmarkPatientId,
    updatedBenchmarkId,
    originalBenchmarkId,
    showBenchmarkIdEditModal,
    isBenchmarkInsurancesLoading,

    setUpdatedBenchmarkId,
    handleBenchmarkIdSubmit,
    handleBenchmarkIdUpdate,
    setShowBenchmarkIdEditModal,
  } = useBenchmarkInsurances();

  return (
    <Grid container>
      <Grid item xs={12} style={{ textAlign: "left" }}>
        <Grid
          container
          className="d-flex align-items-center justify-content-between"
        >
          <Grid item xs={10}>
            <div className="patient-form__info--header mt-1 d-flex align-items-center">
              Billing Software Insurance Information
              <span style={{ fontSize: "14px", fontWeight: "500" }}>
                {originalBenchmarkId && (
                  <i className="ml-1">(ID: {originalBenchmarkId})</i>
                )}

                {[USER_ROLES.ADMIN, USER_ROLES.USER].includes(userRole) && (
                  <Tooltip title="Update Benchmark ID">
                    <Button
                      variant="text"
                      color="secondary"
                      onClick={() => setShowBenchmarkIdEditModal(true)}
                    >
                      <EditIcon className="patient-edit-icon billing-cycle-edit-icon" />
                    </Button>
                  </Tooltip>
                )}
              </span>
            </div>
          </Grid>
          {benchmarkPatientId &&
            [USER_ROLES.ADMIN, USER_ROLES.USER].includes(userRole) && (
              <Grid item xs={2} style={{ textAlign: "right" }}>
                <Button
                  variant="text"
                  color="secondary"
                  className="device-edit-button mr-2"
                  component="a"
                  href={`${API_BASE_URL_BENCHMARK}/pm/Patient/PatientEntry.aspx?patientId=${benchmarkPatientId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <EditIcon className="patient-edit-icon billing-cycle-edit-icon" />
                  Edit
                </Button>
              </Grid>
            )}
        </Grid>
      </Grid>
      {isBenchmarkInsurancesLoading ? (
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          className="mb-3"
        >
          <LoadingSpinner />
        </Grid>
      ) : (
        <Grid item xs={12}>
          <InsuranceInformationDetail
            allowEdit={false}
            isBenchmarkData={true}
            title="PRIMARY INSURANCE"
            type={"primaryInsurance"}
          />
          <InsuranceInformationDetail
            allowEdit={false}
            isBenchmarkData={true}
            title="SECONDARY INSURANCE"
            type={"secondaryInsurance"}
          />
          <InsuranceInformationDetail
            allowEdit={false}
            isBenchmarkData={true}
            title="TERTIARY INSURANCE"
            type={"tertiaryInsurance"}
          />
        </Grid>
      )}

      {showBenchmarkIdEditModal && (
        <ModalWrapper
          show={showBenchmarkIdEditModal}
          onClose={() => {
            setUpdatedBenchmarkId(originalBenchmarkId);
            setShowBenchmarkIdEditModal(false);
          }}
          disableEnforceFocus
          title="Update Benchmark ID"
        >
          <FormTextField
            fullWidth
            label="Benchmark ID"
            value={updatedBenchmarkId}
            inputProps={{ maxLength: 10 }}
            onChange={(e) => {
              handleBenchmarkIdUpdate(e.target.value);
            }}
          />
          <div className="d-flex flex-end" style={{ gap: "10px" }}>
            <Button
              color="secondary"
              variant="outlined"
              onClick={() => {
                setUpdatedBenchmarkId(originalBenchmarkId);
                setShowBenchmarkIdEditModal(false);
              }}
            >
              Cancel
            </Button>

            <SubmitButton
              handleClick={handleBenchmarkIdSubmit}
              isLoading={isSubmitting}
              disabled={isSubmitClicked}
            />
          </div>
        </ModalWrapper>
      )}
    </Grid>
  );
};

export default BenchmarkInsurances;
